module.exports = __webpack_public_path__ + "img/mood.4a44c00f.jpg";